import { Component, OnInit, Renderer2, Output, EventEmitter } from '@angular/core';
import templateString from './timeSlotForm.component.html';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { HttpClient } from '@angular/common/http';
import { TimeSlot } from '../../../models/timeSlot.model';

@Component({
  standalone: false,
  template: templateString
})
export class TimeSlotFormComponent implements OnInit {
    @Output() action = new EventEmitter();

    public timeSlotId: any;
    public timeSlot: any;
    public submitted: boolean;
    public actionTitle: string;

    constructor(
        private http: HttpClient,
        private bsModalRef: BsModalRef,
        private renderer: Renderer2,
        private toastr: ToastrService
    ) {
        this.renderer.addClass(document.body, 'md-skin');
        this.renderer.addClass(document.body, 'landing-page');
        this.renderer.addClass(document.body, 'fixed-nav');
    }

    ok(isValid) {
        this.submitted = true;

        if (isValid) {
            if (this.timeSlotId === null) {
                this.http.post("time_slots", this.timeSlot).subscribe(() => {
                    this.action.emit(true);
                    this.bsModalRef.hide();
                }, (response) => {
                    this.toastr.error(response.error.error);
                });
            } else {
                this.http.put("time_slots/" + this.timeSlot.id, this.timeSlot).subscribe(() => {
                    this.action.emit(true);
                    this.bsModalRef.hide();
                }, (response) => {
                    this.toastr.error(response.error.error);
                });
            }
        }
    }

    cancel() {
        this.bsModalRef.hide();
    }

    toTimepickerDate(value) {
        return value ? new Date(value) : null;
    }

    ngOnInit() {
        if (this.timeSlotId === null) {
            this.actionTitle = "toevoegen";
            this.timeSlot = new TimeSlot({
                name: null,
                start_time: new Date(2000, 0, 1, 8, 0),
                end_time: new Date(2000, 0, 1, 17, 0),
                is_part_of_working_day: true
            });
        } else {
            this.actionTitle = "wijzigen";
            this.http.get("time_slots/" + this.timeSlotId).subscribe(x => {
                this.timeSlot = new TimeSlot(x);
                this.timeSlot.start_time = this.toTimepickerDate(this.timeSlot.start_time);
                this.timeSlot.end_time = this.toTimepickerDate(this.timeSlot.end_time);
            });
        }
    }
}
